/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Detail_Sub_CategoriesInputs */

const en_directory_taxonomy_detail_sub_categories = /** @type {(inputs: Directory_Taxonomy_Detail_Sub_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-categories`)
};

const zh_directory_taxonomy_detail_sub_categories = /** @type {(inputs: Directory_Taxonomy_Detail_Sub_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子分类`)
};

/**
* | output |
* | --- |
* | "Sub-categories" |
*
* @param {Directory_Taxonomy_Detail_Sub_CategoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_detail_sub_categories = /** @type {((inputs?: Directory_Taxonomy_Detail_Sub_CategoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Detail_Sub_CategoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_detail_sub_categories(inputs)
	return zh_directory_taxonomy_detail_sub_categories(inputs)
});
export { directory_taxonomy_detail_sub_categories as "directory.taxonomy_detail.sub_categories" }